import React, { HTMLAttributes, ReactNode } from 'react';
import { getClassNames } from '../../utils';
import withTheme from '../../hocs/withTheme';
import './Grid.css';

interface RowProps extends HTMLAttributes<HTMLDivElement> {
    children?: ReactNode;
    className?: string;
}

const Row: React.FC<RowProps> = ({ children = null, className = '', ...props }) => {
    return (
        <div {...props} className={getClassNames(className, 'row')}>
            {children}
        </div>
    );
};

export default withTheme(Row);